(() => {
  angular
    .module('gm.common.directives')
    .directive('gmSetFocus', gmSetFocusDirective);

  function gmSetFocusDirective() {
    'ngInject';

    return {
      restrict: 'A',
      scope: {
        gmSetFocus: '='
      },

      link(scope, element) {
        scope.gmSetFocus = scope.gmSetFocus || {};
        scope.gmSetFocus.focus = () => element.focus();
      },
    };
  }
})();
